import { BRAND_COLORS } from "../theme/colors.js";

// Each project featured in the Work section. Image-first projects use `image`
// as the hero; logo-first projects use `logo` over a colored gradient `bg`.
export const PROJECTS = [
  {
    id: "goalkeeper",
    name: "Goalkeeper.com",
    tagline: "Platform · Data · Commerce",
    description:
      "Goalkeeper.com is the largest goalkeeper project in the world, about to announce some of the largest partnerships in the world of football.",
    logo: "/work/gk-short-green.svg",
    bg: "radial-gradient(circle at 30% 25%, rgba(154,173,23,0.18), transparent 60%), linear-gradient(135deg, rgba(154,173,23,0.10), rgba(0,240,200,0.04))",
    color: BRAND_COLORS.green,
    href: "https://goalkeeper.com",
  },
  {
    id: "waves-and-wiggles",
    name: "Waves and Wiggles",
    tagline: "Children's books · Storytelling",
    description:
      "Waves and Wiggles is a children's book about everything. Let Terran and Tobi the tardigrades take you on a mind blowing journey.",
    image: "/work/ww-tea-time.png",
    color: BRAND_COLORS.cyan,
    bg: "linear-gradient(135deg, rgba(0,240,200,0.10), rgba(123,106,232,0.06))",
  },
  {
    id: "seaside-rendezvous",
    name: "Seaside Rendezvous",
    tagline: "Destination weddings · Hospitality",
    description:
      "One of the world's top 3 global destination wedding planners. Brand identity, booking platform, and concierge tooling for stress-free weddings in paradise — with 24/7 in-country support.",
    logo: "/work/seaside-rendezvous.png",
    bg: "radial-gradient(circle at 30% 25%, rgba(91,123,138,0.32), transparent 60%), linear-gradient(135deg, rgba(43,127,224,0.16), rgba(184,112,90,0.06))",
    color: BRAND_COLORS.blue,
    logoSize: 320,
    href: "https://www.seasiderendezvousweddings.com/",
  },
  {
    id: "gatorade",
    name: "Gatorade",
    tagline: "Sports nutrition · Event ops",
    description:
      "We have dealt in tons of Gatorade per weekend at some of Gatorade's largest events globally. 15,000 athletes, no problem.",
    logo: "/work/gatorade.svg",
    bg: "radial-gradient(circle at 30% 25%, rgba(255,107,0,0.22), transparent 60%), linear-gradient(135deg, rgba(255,107,0,0.10), rgba(244,148,78,0.04))",
    color: "#EF3C42",
    logoSize: 220,
  },
];
